import { FeaturesEnum } from '~/features/types';
import { PermissionEnum } from '~/roles/types';

export default [
  {
    path: '/reports',
    meta: {
      auth: true,
      permissions: [PermissionEnum.DYNAMIC_REPORTS],
      feature: FeaturesEnum.DYNAMIC_REPORTS,
    },
    component: () => import('~/common/layouts/default.vue'),
    children: [
      {
        path: 'hazard-stats',
        name: 'hazardStats',
        component: () => import('~/reports/pages/HazardStats.vue'),
      },
      {
        path: 'hazard-causes',
        name: 'hazardCauses',
        component: () => import('~/reports/pages/HazardCauses.vue'),
      },
      {
        path: 'high-energy-hazard',
        name: 'highEnergyHazard',
        component: () => import('~/reports/pages/HighEnergyHazard.vue'),
      },
      {
        path: 'safety-roadmap',
        name: 'safetyRoadmap',
        component: () => import('~/reports/pages/SafetyRoadmap.vue'),
      },
      {
        path: 'engagement',
        name: 'engagement',
        component: () => import('~/reports/pages/Engagement.vue'),
      },
      {
        path: 'hydrogen-daily-tour-trends',
        name: 'hydrogenDailyTourTrends',
        component: () => import('~/reports/pages/HydrogenDaily.vue'),
      },
    ],
  },
];
